import { useId, type ReactNode } from 'react';
import { Badge, Paper, Text, Title } from '@cowbell/ui';
import type { EmptyCopy } from './connectors.view';
import styles from './Connectors.module.css';

interface ConnectorSectionProps {
  readonly title: string;
  readonly count: number;
  /** Shown in place of the children when `count` is zero. */
  readonly empty: EmptyCopy;
  readonly children: ReactNode;
}

export default function ConnectorSection({
  title,
  count,
  empty,
  children,
}: ConnectorSectionProps) {
  const headingId = useId();

  return (
    <section aria-labelledby={headingId} className={styles.section}>
      <div className={styles.sectionHeader}>
        <Title order={4} id={headingId}>
          {title}
        </Title>
        <Badge variant="light" color="gray" size="sm">
          {count}
        </Badge>
      </div>
      {count > 0 ? (
        children
      ) : (
        <Paper withBorder className={styles.empty}>
          <Text fw={600} size="sm">
            {empty.title}
          </Text>
          {empty.body && (
            <Text c="dimmed" size="sm">
              {empty.body}
            </Text>
          )}
        </Paper>
      )}
    </section>
  );
}
